import { useSprintMutation, useSprintQueryClient, SprintMutationResult } from "sprint-common-web";

import { RejectCloudFileRequest } from "../../../../../common/api/master-api/cloud-files/reject/RejectCloudFileRequest";
import { useCloudFileApi } from "../../../../../common/api/master-api/cloud-files/useCloudFileApi";
import { CloudFileQueryKey } from "../../../details/common/CloudFileQueryKey";

export interface UseRejectCloudFile {
    rejectCloudFile: SprintMutationResult<RejectCloudFileRequest, void>;
}

export const useRejectCloudFile = ({ invalidationKey }: { invalidationKey?: string }): UseRejectCloudFile => {
    const cloudFileApi = useCloudFileApi();
    const sprintQueryClient = useSprintQueryClient();

    const rejectCloudFile = useSprintMutation<RejectCloudFileRequest>({
        mutationFn: async (request: RejectCloudFileRequest) => {
            return cloudFileApi.rejectCloudFile(request);
        },
        onSettled: async () => {
            await sprintQueryClient.invalidateQueries({
                queryKey: [CloudFileQueryKey.CloudFileDetails, invalidationKey]
            });
        }
    });

    return {
        rejectCloudFile
    };
};
